import { memo, Fragment } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconFolder from '@hiredigital/ui/Icon/tritone/folder.inline.svg';
import Styles from './Profile.module.scss';

const PortfolioItem = dynamic(() => import('@components/PortfolioList/PortfolioItem'));
const PortfolioList = dynamic(() => import('@components/PortfolioList/PortfolioList'));

const Portfolios = memo(
  ({
    user,
    portfolio,
    resourceUuid,
    type,
    handlePortfolioNavigate,
    portfolioItemUuid,
    isPrivate,
  }) => {
    return (
      <Fragment>
        {portfolio?.results.length > 0 && (
          <div className={classNames(Styles.section)} style={{ flexDirection: 'column' }}>
            <h3 className={Styles.title}>
              <IconFolder />
              {`Portfolio`}
            </h3>
            <span className={Styles.printPortfolioList}>
              {/* This is only for print styles */}
              {portfolio.results.slice(0, 6).map(
                (item, index) =>
                  item && (
                    <div
                      key={item.id}
                      id={item.id}
                      className={classNames(Styles.printPortfolioItem)}>
                      <PortfolioItem item={item} />
                    </div>
                  )
              )}
            </span>
            <span className={Styles.portfolioList}>
              <PortfolioList
                isPrivate={isPrivate}
                data={portfolio.results}
                creator={user}
                resourceUuid={resourceUuid}
                type={type}
                onNavigate={handlePortfolioNavigate}
                defaultActiveItemUuid={portfolioItemUuid}
                withLimit
                externalSource
              />
            </span>
          </div>
        )}
      </Fragment>
    );
  }
);

Portfolios.propTypes = {
  isPrivate: PropTypes.bool,
  className: PropTypes.string,
};

export default Portfolios;
